export const PROFILE_ROLE = {
    subscriberAdministrator: 'Subscriber_Administrator',
    companyAdministrator: 'Company_Administrator',
    buAccessAdministrator: 'BU_Access_Administrator',
    buSubscriberViewer: 'BU_Subscriber_Viewer',
    administrator: 'b9874387-6a91-4df9-9e34-48f3d321c3a9'
}
